import { Form } from "domains/3d/interfaces";
import { ReferenceAsset } from "domains/inference/interfaces/InferenceGenerator";
import { GetModelsByModelIdApiResponse } from "infra/api/generated/api";

export function getFormDefaultValue(
  input: NonNullable<GetModelsByModelIdApiResponse["model"]["inputs"]>[number]
) {
  return (
    input.default ??
    {
      string: "",
      string_array: [],
      number: undefined,
      number_array: [],
      boolean: false,
      file: undefined,
      file_array: [],
    }[input.type]
  );
}

export function getStepSizeForRange(min: number, max: number): number {
  const diff = max - min;
  if (diff <= 0) return 1;
  const magnitude = Math.floor(Math.log10(diff));

  const baseStep = Math.pow(10, magnitude - 1);
  if (diff <= 10) return 0.1;
  if (diff <= 100) return 1;
  return baseStep;
}

export function getFirstFileInput(
  model: GetModelsByModelIdApiResponse["model"] | undefined
) {
  return model?.inputs?.find(
    (input) => input.type === "file" || input.type === "file_array"
  );
}

export function getFirstPromptInput(
  model: GetModelsByModelIdApiResponse["model"] | undefined
) {
  return model?.inputs?.find((input) => !!input.prompt);
}

export function getFirstImage(
  model: GetModelsByModelIdApiResponse["model"] | undefined,
  form: Form
): ReferenceAsset | undefined {
  const firstFileInput = getFirstFileInput(model);

  if (!firstFileInput) return undefined;

  const value = form[firstFileInput.name];

  if (
    firstFileInput.type === "file" &&
    typeof value === "object" &&
    "url" in value &&
    "id" in value
  ) {
    return value;
  }

  if (
    firstFileInput.type === "file_array" &&
    Array.isArray(value) &&
    value.length > 0
  ) {
    const firstItem = value[0];
    if (
      typeof firstItem === "object" &&
      "url" in firstItem &&
      "id" in firstItem
    ) {
      return firstItem;
    }
  }

  return undefined;
}

export function getIsVeo3Model(
  model: GetModelsByModelIdApiResponse["model"] | undefined
) {
  return !!model && ["model_staging_veo3", "model_veo3"].includes(model.id);
}
